






import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'NoWrapText',
  props: {
    text: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const formattedText = computed(() => props.text?.replace(/-/g, '‑'));

    return {
      formattedText,
    };
  },
});
